import SupplierTooltip from './SupplierTooltip';
export default SupplierTooltip;
